<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 17/9/2021
  -->

<template>
	<div></div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "BasePaymentMethodsView",
	extends: BaseComponent,

	methods: {
		async startStripeConnectionFlow(){
			let _ = this.$analyticManager.trackEvent("Connect stripe clicked", this.analyticsPropsMethod())
			try{
				let thisUrl = this.getBrandedLink(window.location.href)
				let thisUrlPath = window.location.pathname + window.location.search
				let authUrl = await this.$dataManager.apiGetStripeAuthUrl({originUrl: thisUrl})
				await this.go("StripeWizard", {}, {authUrl, redirectUrl: thisUrlPath})
			} catch (error) {
				this.handleError(error)
			}
		},

		async startCloverConnectionFlow(){
			let _ = this.$analyticManager.trackEvent("Connect clover clicked", this.analyticsPropsMethod())
			try{
				let thisUrl = window.location.href
				let authUrl = await this.$dataManager.apiGetCloverOAuthStart({originUrl: thisUrl})
				await this.goSaveOrigin("CloverWizard", {}, {authUrl})
			} catch (error) {
				this.handleError(error)
			}
		},
	},
}
</script>

<style lang="scss">

</style>
